module.exports = __webpack_public_path__ + "static/media/privacy.b567fcc9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/privacy.png
 ** module id = 1618
 ** module chunks = 0
 **/